import React from 'react'
import { Button, Table, Container, Row, Col, Label, Input } from 'reactstrap'
import '../css/QuoteViewController.css'
import { downloadOpenInvoicePDF } from '../model/request/pdf'
import DropDownTextField from '../view/DropDownTextField'
import {
    getBanks,
    removePrivateBankInfo,
} from '../model/request/bank'

class OpenInvoiceReportViewController extends React.Component {

    constructor(props) {
        super(props)
        this.state = {

        }
    }


    render() {
        return <Container>
            <Row><Col>
            <Container>
                <Button
                    color='primary'
                    onClick={() => downloadOpenInvoicePDF()}
                >Download Open Invoices</Button>
            </Container>
            </Col></Row>
        </Container>
    }
}

export default OpenInvoiceReportViewController;
